import React from "react";

const StatusComp = (props)=>{
    
    let statusClass = "status";
    if (props.status === "Approved" || props.status === "Active") {
        statusClass = `${statusClass} status-green`;
    } else if (props.status === "Pending") {
        statusClass = `${statusClass} status-purple`;
    } else if (props.status === "Rejected") {
        statusClass = `${statusClass} status-orange`;
    } else if (props.status === "Withdrawn" || props.status === "Cancelled" || props.status.includes('Close') ) {
        statusClass = `${statusClass} status-grey`;
    }
    
    return(
        <span className={statusClass}>{props.children}</span>
    )
};

export default StatusComp;

